<template>
    <b-row>
        <b-col cols="12" md="4" lg="2">
            <app-date-picker
                v-model="filters.from"
                placeholder="Desde"
                id="desde"
            ></app-date-picker>
        </b-col>  
        <b-col cols="12" md="4" lg="2">
            <app-date-picker
                v-model="filters.to"
                placeholder="Hasta"
                id="hasta">
            </app-date-picker>
        </b-col>  
        <b-col cols="12" md="4" lg="2">
            <app-form-select-input
                placeholder="Estado"
                :options="ticketStatuses"
                v-model="filters.statusId">
            </app-form-select-input>
        </b-col>  
        <b-col cols="12" md="4" lg="2">
            <app-form-select-input
                placeholder="Módulo"
                :options="modules"
                v-model="filters.moduleId">
            </app-form-select-input>
        </b-col> 
        <b-col cols="12" md="4" lg="2" >
            <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i> Filtrar</b-button>
        </b-col>
        <b-col cols="12" md="4" lg="2" >
            <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i> Reiniciar</b-button>
        </b-col>
        <b-col cols="12" md="4" lg="2">
            <b-form-input type="number" v-model="filters.ticketNumber" placeholder="numero de ticket"></b-form-input>
        </b-col>
        <b-col cols="12" md="4" lg="2">
            <app-form-text-input
                placeholder="Descripción"
                v-model="filters.description"
            ></app-form-text-input>
        </b-col>
        <b-col cols="12" md="4" lg="2">
            <app-form-text-input
                placeholder="Título"
                v-model="filters.title"
            ></app-form-text-input>
        </b-col>
    </b-row>  

</template>
<script>
export default {
    data () {
        return {
            filters: {
                from: '',
                to: '',
                statusId: '',
                moduleId: '',
                ticketNumber: '',
                description: '',
                title: ''
            },
            ticketStatuses: [],
            modules: []
        }
    },
    methods: {
        async loadTicketStatuses() {
            const {data} = await repo.get('tickets/statuses-page-support', null, 'Lo sentimos, ha ocurrido un error');
            this.ticketStatuses = data;
        },
        async loadTicketModules(){
            const {data} = await repo.get('security/modules', null, 'Lo sentimos, ha ocurrido un error');
            this.modules = data;
        },
        clearFilters() {
            this.filters.statusId = '';
            this.filters.moduleId = '';
            this.filters.from = '';
            this.filters.to = '';
            this.filters.ticketNumber = '';
            this.filters.description = '';
            this.filters.title = '';
            this.$emit('filter', null);
        }
    },
    mounted() {
        this.loadTicketStatuses();
        this.loadTicketModules();
    }
}
</script>